export class ProductReplyQuestionDto {
  message: string;
  questionId: number;
  media: string[];
  constructor() {
    this.message = '';
    this.questionId = 0;
    this.media = [];
  }
}
